/* ============================================================================
 * projectIdExtractor.ts - Project ID extraction utilities
 * ============================================================================ */

import type { NodeOperation } from '@/shared/types/projectData';
import { getProjectIdFromNodeId } from '@/features/projects/MultiProjectContext';

/**
 * Extract project ID from operation based on type
 * Handles all operation types and cleans up comma-separated IDs
 */
export function extractProjectIdFromOperation(operation: NodeOperation): string | null {
  let projectId: string | null = null;

  switch (operation.type) {
    case 'create':
      if (operation.parentId) {
        projectId = getProjectIdFromNodeId(operation.parentId);
      }
      break;
    case 'update':
    case 'delete':
    case 'delete-tree':
    case 'restore-tree':
    case 'move':
    case 'progress-update':
      if (operation.nodeId) {
        projectId = getProjectIdFromNodeId(operation.nodeId);
      }
      break;
    case 'batch-update':
      if (operation.updates?.[0]?.nodeId) {
        projectId = getProjectIdFromNodeId(operation.updates[0].nodeId);
      }
      break;
    case 'batch-delete':
      if (operation.nodeIds?.[0]) {
        projectId = getProjectIdFromNodeId(operation.nodeIds[0]);
      }
      break;
    case 'group-move':
      if (operation.nodeId) {
        projectId = getProjectIdFromNodeId(operation.nodeId);
      }
      break;
  }

  // Clean up any comma-separated project IDs
  if (projectId && projectId.includes(',')) {
    projectId = projectId.split(',')[0].trim();
  }

  return projectId;
}
